/* eslint-disable @typescript-eslint/no-explicit-any */
import { executeApiCall } from 'services/api';
import { getMutations } from 'entities/hooks/mutation';
import { ProjectService, TaskWithSub } from '../types';

type RequestServiceParams = Omit<ProjectService, 'id' | 'name' | 'costCalculation'> & {
  project: string;
  expectedDate: string;
};

export const projectServiceMutations = getMutations({
  requestProjectServiceAddition: {
    action: async (payload: RequestServiceParams): Promise<TaskWithSub> => {
      return executeApiCall({
        path: '/projects/services',

        payload,
      });
    },

    messages: {
      success: (t) => ({
        title: t('service-added-with-success'),
        type: 'success',
      }),

      error: (t) => ({
        title: t('error-while-adding-service'),
        type: 'error',
      }),
    },
  },
});
